export default __webpack_public_path__ + "static/media/reset.7ae92aa7.svg";